import React from 'react';
import { Button, Text } from '@fluentui/react-components';
import { mergeStyleSets } from '@fluentui/react';
import { sharedStyles, styles as WelcomeStyles } from './index';
import { useTranslation } from 'react-i18next';

export type ILoginProps = {
  email?: string;
  onBackToLogin?: () => void;
};
const RetrievePwdSuccess: React.FC<ILoginProps> = (props) => {
  const { email = '', onBackToLogin } = props;
  const { t } = useTranslation();

  return (
    <div className={sharedStyles.container}>
      <Text as='h3' block className={WelcomeStyles.subTitle}>
        {t('welcome.retrievePwdSuccess.title')}
      </Text>
      <Text block className={styles.description}>
        {t('welcome.retrievePwdSuccess.titleDescription1')} {email} {t('welcome.retrievePwdSuccess.titleDescription2')}
      </Text>

      <form className={styles.form}>
        <div className={styles['form-item']}>
          <Button className={styles.primaryButton} appearance='secondary' size='large' onClick={onBackToLogin}>
            {t('welcome.backToLogin')}
          </Button>
        </div>
      </form>
    </div>
  );
};

export default RetrievePwdSuccess;

const styles = mergeStyleSets({
  description: {
    whiteSpace: 'nowrap !important',
    fontSize: '12px !important',
    textAlign: 'center !important'
  },

  form: {},

  ['form-item']: {
    display: 'flex',
    flexDirection: 'column',
    textAlign: 'center',
    gap: '4px',
    marginTop: '24px',
    alignItems: 'center',
    '& label': {
      fontWeight: 'bold'
    }
  },

  ['form-ctrl']: {
    width: '100%'
  },

  primaryButton: {
    marginTop: '160px !important',
    width: '192px'
  }
});
